/* eslint-disable no-console */
import zukeeper from 'zukeeper';
import {create} from 'zustand';

interface userStore {
  userToken: string;
  aiToken: string;
  userDetails: any;
  permission: any[];
  auth0Permissions: any[];
  roleAdded: any[];
  // userPermission: undefined | any;
  userRoles: undefined | any;
  // userAuth0Roles: string[];
  ctaHome: any[];
  chatSessionId: string | null;
  setUserToken: (token: string) => void;
  setAIToken: (aiToken: string) => void;
  setUserDetails: (userDetails: any) => void;
  setPermission: (permission: any) => void;
  setRoleAdded: (roleAdded: any) => void;
  setUserPermission: (userPermission: any) => void;
  setRoles: (userRoles: any) => void;
  setAuth0Permissions: (data: any) => void;
  // setUserAuth0Roles: (userAuth0Roles: string[]) => void;
  setCtaHome: (ctaHome: any[]) => void;
  setChatSessionId: (chatSessionId: string | null) => void;
}

const useUserStore = create<userStore>(
  zukeeper((set: any) => ({
    userToken: '',
    aiToken: '',
    userDetails: {},
    permission: [],
    roleAdded: [],
    // userPermission: undefined,
    userRoles: undefined,
    auth0Permissions: [],
    // userAuth0Roles: [],
    ctaHome: [],
    chatSessionId: null,
    setUserToken: (token: string) => {
      set(() => ({userToken: token}));
    },
    setAIToken: (aiToken: string) => {
      set(() => ({aiToken}));
    },
    setUserDetails: (userDetails: any) => {
      set(() => ({userDetails}));
    },
    setPermission: (permission: any) => set(() => ({permission})),
    setRoleAdded: (roleAdded: any) => {
      set(() => ({roleAdded}));
    },
    setUserPermission: (userPermission: any) => {
      set(() => ({userPermission}));
    },
    setRoles: (userRoles: any) => {
      set(() => ({userRoles}));
    },
    setAuth0Permissions: (auth0Permissions: any) => {
      set(() => ({auth0Permissions}));
    },
    setCtaHome: (ctaHome: any[]) => {
      set(() => ({ctaHome}));
    },
    setChatSessionId: (chatSessionId: string | null) => {
      set(() => ({chatSessionId}));
    }
  }))
);

(window as any).store = useUserStore;

export default useUserStore;
